import React, { useEffect, useState } from 'react'
import LayoutWithAccountCard from '../../../layout/Layout/layout-account-card'
import MonthlyStatement from './monthly-statement'
export default function CurrentMonthStatement() {
   
    return (
        <div>
           <LayoutWithAccountCard breadCumKey='CURRENT_MONTH'>
           <MonthlyStatement month="1"/>
            </LayoutWithAccountCard>  
        </div>
    )
}
